import { Container, makeStyles, Typography, Hidden, withStyles, Menu, MenuItem } from '@material-ui/core';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { FormattedMessage, useIntl } from 'react-intl';
import CircularProgress from '@material-ui/core/CircularProgress';
import { ValidatorForm } from 'react-material-ui-form-validator';
import DatePickerValidator from '../LeaveApplication/component/Validator/DatePickerValidator';
import Button from '@material-ui/core/Button';
import React from 'react';
import MUIDataTable from 'mui-datatables';
import { getMuiTheme, pxToRem, tableStyle } from '../UIComponent/CommonStyle';
import createBreakpoints from '@material-ui/core/styles/createBreakpoints';
import moment from 'moment';
import {
    setReqApprovalHistoryColumns,
    setReqApprovalHistoryOptions,
} from '../CompLeaveReqsApproval/component/TableSetting';
import GenerateCSV from './component/DetailsReport';
import { getCashOutApprovalHistory } from './api/ApprovalAPI';
import { CashOutApprovalHistoryCollection } from '../Function/CashOutApproval';
import { setApprovalHistoryColumns, setApprovalHistoryOptions } from './TableSetting';
import LoadingOverlay from 'react-loading-overlay';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import DetailsReport from './component/DetailsReport';
import SummaryReport from './component/SummaryReport';

const StyledMenu = withStyles({
    paper: {
        border: '1px solid #d3d4d5',
    },
})((props) => (
    <Menu
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
        }}
        {...props}
    />
));

const StyledMenuItem = withStyles((theme) => ({
    root: {
        '&:focus': {
            '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
                color: theme.palette.common.white,
            },
        },
    },
}))(MenuItem);

const useStyles = makeStyles((theme) => ({
    ...tableStyle(theme),
    container: {
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(4),
    },
    datePickerFrom: {
        width: '25%',
        paddingRight: '10px',
    },
    datePickerTo: {
        width: '25%',
        paddingRight: '20px',
    },
    datePickerInput: {
        textAlign: 'left',
        padding: '1rem 1rem',
        fontSize: pxToRem(14),
        border: '1px solid #B8B8B8',
        borderRadius: 5,
        outline: 'none',
        height: 'fit-content',
        minWidth: '100%',
        [breakpoints.up('md')]: {
            fontSize: pxToRem(16),
            height: pxToRem(61),
        },
    },
    datePickerCalendar: {
        border: '1px solid #B8B8B8',
        fontSize: 8,
        [breakpoints.up('md')]: {
            fontSize: 10,
        },
    },
    searchForm: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 'auto',
        marginRight: 0,
    },
    searchButton: {
        height: 'fit-content',
        marginRight: '10px',
    },
    exportButton: {
        height: 'fit-content',
    },
    approvalHistoryHeader: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '10px',
    },
    circularProgress: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: theme.spacing(1),
    },
}));

const breakpoints = createBreakpoints({});

export default function ApprovalHistory() {
    const form = React.useRef();
    const classes = useStyles();
    const intl = useIntl();

    const today = moment();
    const lastMonth = moment().subtract(1, 'months');
    const [searchFromDate, setSearchFromDate] = React.useState({
        day: Number(lastMonth.format('DD')),
        month: Number(lastMonth.format('MM')),
        year: Number(lastMonth.format('YYYY')),
    });
    const [searchToDate, setSearchToDate] = React.useState({
        day: Number(today.format('DD')),
        month: Number(today.format('MM')),
        year: Number(today.format('YYYY')),
    });
    const [showTable, setShowTable] = React.useState(false);
    const [tableData, setTableData] = React.useState([]);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [isActive, setIsActive] = React.useState(false);

    React.useEffect(() => {
        let isMounted = true;
        if (isMounted) {
            handleSearch();
        }
        return () => {
            isMounted = false;
        };
    }, []);

    const handleSearch = async () => {
        if (searchFromDate && searchToDate) {
            setShowTable(false);
            const response = await getCashOutApprovalHistory(
                searchFromDate,
                searchToDate
            );
            if (response.status === 200) {
                setTableData(CashOutApprovalHistoryCollection(response.data, intl));
            } else {
                setTableData([]);
            }
            setShowTable(true);
        }
    };

    const handleOpenMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const columns = setApprovalHistoryColumns();
    const options = setApprovalHistoryOptions();

    return (
        <Container maxWidth={false} className={classes.container}>
            <MuiThemeProvider theme={getMuiTheme()}>
                <div className={classes.approvalHistoryHeader}>
                    <Typography
                        component='h1'
                        variant='h5'
                        align='left'
                        style={{ fontWeight: 600 }}
                    >
                        {intl.formatMessage({ id: 'navigation.cash_out_history' })}
                    </Typography>
                    <ValidatorForm
                        className={classes.searchForm}
                        ref={form}
                        onSubmit={handleSearch}
                        onError={(errors) => errors}
                        style={{ position: 'relative', zIndex: '999' }}
                    >
                        <span style={{ marginRight: '10px', fontWeight: 600, fontSize: pxToRem(16) }}>
                            {intl.formatMessage({
                                id: 'cash_out.date_approved_from',
                            })}
                        </span>
                        <FormattedMessage id='common.from'>
                            {(message) => (
                                <DatePickerValidator
                                    wrapperClassName={classes.datePickerFrom}
                                    value={searchFromDate}
                                    onChange={setSearchFromDate}
                                    inputPlaceholder={message + ' *'}
                                    shouldHighlightWeekends
                                    inputClassName={classes.datePickerInput}
                                    calendarClassName={
                                        classes.datePickerCalendar
                                    }
                                    calendarPopperPosition='bottom'
                                    validators={['required']}
                                />
                            )}
                        </FormattedMessage>
                        <span style={{ marginRight: '10px', fontWeight: 600, fontSize: pxToRem(16) }}>
                            {intl.formatMessage({
                                id: 'common.to',
                            })}
                        </span>
                        <FormattedMessage id='common.to'>
                            {(message) => (
                                <DatePickerValidator
                                    wrapperClassName={classes.datePickerTo}
                                    value={searchToDate}
                                    onChange={setSearchToDate}
                                    inputPlaceholder={message + ' *'}
                                    shouldHighlightWeekends
                                    inputClassName={classes.datePickerInput}
                                    calendarClassName={
                                        classes.datePickerCalendar
                                    }
                                    calendarPopperPosition='bottom'
                                    validators={['required']}
                                />
                            )}
                        </FormattedMessage>
                        <Button
                            onClick={handleSearch}
                            variant='contained'
                            className={classes.searchButton}
                        >
                            {intl.formatMessage({ id: 'table.search' })}
                        </Button>
                        {showTable ? (
                            <Hidden smDown>
                                <Button
                                    aria-controls="customized-menu"
                                    aria-haspopup="true"
                                    variant='contained'
                                    className={classes.exportButton}
                                    onClick={handleOpenMenu}
                                >
                                    {intl.formatMessage({id: 'myteam.export'})}
                                </Button>
                                <StyledMenu
                                    id="customized-menu"
                                    anchorEl={anchorEl}
                                    keepMounted
                                    open={Boolean(anchorEl)}
                                    onClose={handleCloseMenu}
                                >
                                    <LoadingOverlay
                                        active={isActive}
                                        styles={{
                                            overlay: base => ({
                                                ...base,
                                                background: '#D0D0D0',
                                                opacity: 0.7,
                                            }),
                                        }}
                                        spinner
                                    >
                                        <StyledMenuItem>
                                            <ListItemIcon>
                                                <DetailsReport
                                                    fromDate={searchFromDate}
                                                    toDate={searchToDate}
                                                    setIsActive={setIsActive}
                                                />
                                            </ListItemIcon>
                                        </StyledMenuItem>
                                        <StyledMenuItem>
                                            <ListItemIcon>
                                                <SummaryReport
                                                    fromDate={searchFromDate}
                                                    toDate={searchToDate}
                                                    setIsActive={setIsActive}
                                                />
                                            </ListItemIcon>
                                        </StyledMenuItem>
                                    </LoadingOverlay>
                                </StyledMenu>
                            </Hidden>
                        ) : (
                            <div />
                        )}
                    </ValidatorForm>
                </div>
                {showTable ? (
                    <MUIDataTable
                        title={intl.formatMessage({
                            id: 'table.employee_list',
                        })}
                        data={tableData}
                        columns={columns}
                        options={options}
                    />
                ) : (
                    <div className={classes.circularProgress}>
                        <CircularProgress />
                    </div>
                )}
            </MuiThemeProvider>
        </Container>
    );
}
